<template>
    <div class="productos">

        <b-spinner variant="primary" v-if="!showForm" class="dvLoading"
                   type="grow" label="Spinning"></b-spinner>

        <div class="dvTitle">
            <h5 class="title">Productos</h5>
            <div class="dvBoton" @click="addProducto">
                Agregar
            </div>
        </div>

        <div class="dvAccion">
            <Search v-model="search" />
        </div>

        <div class="dvTable" ref="content" v-if="showForm">
            <b-table striped hover
                     sticky-header
                     head-variant="dark"
                     :items="items"
                     :fields="fields"
                     :filter="search"
                     :filterIncludedFields="filterOn"
                     responsive
                     id="table-transition"
                     @row-selected="onRowSelected"
            >
                <template v-slot:cell(accion)="row">
                    <i class="far fa-edit hover cursor" style="width: 20px" @click="onRowSelected(row)"></i>
                </template>
            </b-table>
        </div>


    </div>
</template>

<script>
    import Search from "../components/comun/Search";
    import {mapActions, mapState, mapMutations} from 'vuex';
    import Vue from 'vue'

    export default {
        name: "Productos",
        data() {
            return {
                search: '',
                filterOn:['description', 'sku'],
                fields: [
                    {
                        key: 'description',
                        sortable: true,
                        label: 'Descripción',
                        headerTitle: 'Descripción'
                    },
                    {
                        key: 'sku',
                        sortable: true,
                    },
                    {
                        key: 'price',
                        sortable: true,
                        label: 'Precio',
                        formatter: value => {
                            return Vue.filter('currency')(value);
                        }
                    },
                    {
                        key: 'accion',
                        label: '',
                        sortable: false
                    },
                ],
                showForm: false,
                items: []
            }
        },
        components: {Search},

        mounted: function () {
            window.addEventListener("resize", this.resize);
            setTimeout(() => {
                this.resize();
            }, 300);
            this.getProductos().then( data => {
                if (data.current && data.current.data) {
                    this.items = data.current.data;
                }
                this.showForm = true;
            })
        },

        methods: {

            ...mapActions([
                'getProductos'
            ]),

            ...mapMutations([
                'SET_MENU',
            ]),

            onRowSelected: function (row) {
                this.$router.push('/Productos/Edit/' + row.item.id);
            },

            resize: function () {
                if (window.innerWidth <= 992) {
                    this.SET_MENU(false);
                }

                let winHeight = window.innerHeight - 136;
                if (this.$refs.content !== undefined && this.$refs.content.children[0] !== undefined) {
                    if (winHeight < 220) {
                        this.$refs.content.children[0].style.maxHeight = '220px';
                    } else {
                        this.$refs.content.children[0].style.maxHeight = winHeight + 'px';
                    }
                }
            },

            addProducto: function () {
                this.$router.push('/Productos/Add');
            }

        }
    }
</script>

<style scoped lang="scss">

    @import "../style/base";

    .productos {
        padding: 30px;
        border: 1px solid #e6ebf4;
        border-radius: .25rem;
        background-color: #fff;
        margin: 20px;

        animation-name: fade;
        animation-duration: 1.5s;
        animation-timing-function: ease-in-out;

        & .dvBoton {
            @include buttonPrimary(120px, .625rem 1.5rem, $sekaiAzul, $white, $sekaiAzulHover, $sekaiAzulActive);
        }

        & .dvTitle {
            @include flexRow;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 20px;
        }

        & .dvAccion {
            @include flexRow;
            justify-content: flex-end;
            padding-bottom: 20px;

            & .input-group {
                max-width: 240px;
            }
        }

        & .dvTable {
            & .b-table-sticky-header.table-responsive {
                max-height: initial;
            }
        }
    }

</style>